var map = {
	"./advantages.png": "9f91",
	"./bank.png": "cca0",
	"./bind.png": "3bc6",
	"./buying.png": "11b4",
	"./cart.png": "da85",
	"./cartcur.png": "d7dc",
	"./down.svg": "abcb",
	"./fund.png": "ad79",
	"./home.png": "389a",
	"./homecur.png": "66a0",
	"./hunt.png": "1e20",
	"./lang.png": "1af7",
	"./list.png": "6313",
	"./mine.png": "7cac",
	"./minecur.png": "6def",
	"./order.png": "d2ee",
	"./ordercur.png": "99d8",
	"./ordering.png": "fea8",
	"./orderlist.png": "7970",
	"./p.jpg": "5ce9",
	"./paypsw.png": "3bf1",
	"./protection.png": "aded",
	"./psw.png": "28f2",
	"./qs.png": "7f0f",
	"./quit.png": "e12b",
	"./recharge.png": "31fd",
	"./recharger.png": "d748",
	"./refresh.png": "999d",
	"./safe.png": "19df",
	"./service.png": "e22b",
	"./share.png": "5fca",
	"./shipping.png": "2528",
	"./up.png": "bc6b",
	"./withdraw.png": "d036",
	"./withdrawr.png": "50d9",
	"./yao.png": "43e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "96e7";